import { t } from "@lingui/macro";
import { Box, Container } from "@mui/material";
import { useCallback, useState } from "react";
import useTilePackNames from "./useTilePackNames";
import useNavUpOnDeviceDisconnect from "../useNavUpOnDeviceDisconnect";
import { WSMBoltTilePack } from "@WahooFitness/wsm-native/dist/esm/types/bolt_map";
import AddMapsEmbed from "./AddMapsEmbed";
import { GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";

const AddMaps = ({ appToken, tilePackId }: { appToken: string; tilePackId?: number }) => {
  useNavUpOnDeviceDisconnect(appToken);

  const [title, setTitle] = useState(t`Add maps`);

  const { tilePackNameTranslations } = useTilePackNames();

  const onTilePackLoad = useCallback(
    (tilePack: WSMBoltTilePack) => {
      setTitle(tilePackNameTranslations[tilePack.id] || tilePack.name);
    },
    [tilePackNameTranslations]
  );

  return (
    <>
      <GlobalHeader title={title} />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <Box
          width="100%"
          height="100%"
          display="flex"
          flexDirection="column"
          p={2}
          justifyContent="space-between"
        >
          <AddMapsEmbed
            appToken={appToken}
            onTilePackLoad={onTilePackLoad}
            tilePackId={tilePackId}
          />
        </Box>
      </Container>
    </>
  );
};

export default AddMaps;
